import { gql } from '@apollo/client';

export const GET_RINGTONES_QUERY = gql`
  query GetRingtonesQuery {
    getRingtones {
      friendlyName
      name
      url
    }
  }
`;
